import React from 'react';
import './DiscordInvite.css';

// The invite to the Clomp Discord server
export const DISCORD_INVITE = 'https://discord.com/invite/GXjzggnh9y';

// A labelled button, for use within a page's content
export function DiscordButton() {
    return (
        <a className="discord-btn" href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer">
            <img src="/img/discord-icon.png" alt="" />
            Join the Discord
        </a>
    );
}
